var alignment_rtlignore_default = {
  "alignLeft": "a7i-I",
  "textWrapNowrap": "tsQTT",
  "alignRight": "grbI1",
  "alignCenter": "CUIoB",
  "sizeFullWidth": "DnKPx",
  "renderedInTable": "trfrb",
  "sizeOriginal": "g-Lf9",
  "sizeContent": "eai0e",
  "sizeSmall": "JeQF4",
  "sizeSmallCenter": "nZzl1",
  "flex": "tJcnS",
  "LEFT": "kUOFn",
  "CENTER": "m2EDK",
  "RIGHT": "_3p40U",
  "AUTO": "XxGZC",
  "JUSTIFY": "gRPrg"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
